import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'UI';

const FormHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <Text type={'h1'} disableGutter>
        {t('order.claim.title', 'Send Claims form')}
      </Text>
      <Text type="lg">
        {t(
          'order.claim.subtitle',
          'File a compensation claim for defective products , Missing part or any wrong delivery mistakes.',
        )}
      </Text>
    </>
  );
};
export default FormHeader;
